<cm-image data-type="noMessages" data-min-height="600"></cm-image>

<div class="row">
    <div class="col-12 offset-sm-6 col-sm-6">
        <div class="card">
            <h2 class="title">{{('Status.Unauthorized' | trans)}}</h2>
            <p class="message">{{('Status.Unauthorized_Message' | trans)}}</p>
            <p class="details">{{('Status.Unauthorized_Potential_Fix' | trans)}}</p>
            <div class="links">
                <a [routerLink]="['/events']">Home</a><br>
                <a href="https://www.cm.com/help/">Help Center</a>
            </div>
        </div>
    </div>
</div>
